
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

const About = () => {
  const { language } = useLanguage();

  const content = {
    aboutUs: language === 'sv' ? 'Om Oss' : 'About Us',
    title: language === 'sv' 
      ? 'Säker drivmedelshantering i marin miljö' 
      : 'Safe fuel handling in marine environment',
    description: language === 'sv'
      ? 'Drivmedelshantering i marin miljö ställer höga krav avseende säkerhet, miljö och servicenivå. Med vår expertis och dedikerade flotta av bunkerfartyg och tankbilar säkerställer vi pålitliga leveranser av marina drivmedel till hela Sverige.'
      : 'Fuel handling in marine environments demands high standards regarding safety, environment, and service level. With our expertise and dedicated fleet of bunker vessels and tank trucks, we ensure reliable deliveries of marine fuels throughout Sweden.',
    readMore: language === 'sv' ? 'Läs mer om oss' : 'Read more about us'
  };

  return (
    <section className="relative h-screen flex items-center justify-center bg-[url('/images/stockholm.jpg')] bg-cover bg-center md:bg-fixed bg-no-repeat">
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/40"></div>
      
      <div className="container mx-auto px-4 z-10">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center bg-black/40 backdrop-blur-sm rounded-xl p-8 md:p-12"
          >
            <span className="inline-block px-4 py-1 mb-6 text-sm font-medium bg-white/20 backdrop-blur-sm rounded-full text-white">
              {content.aboutUs}
            </span>
            <h2 className="text-2xl md:text-5xl font-bold text-white mb-6 break-words">
              {content.title}
            </h2>
            <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              {content.description}
            </p>
            <motion.div
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <Link
                to="/about"
                className="inline-block px-10 py-4 text-lg bg-primary text-white rounded-lg font-medium transition-all hover:shadow-lg"
              >
                {content.readMore}
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
